import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const filtersDirectoryRoute: InvariantJiraRoute = {
	name: 'filters-directory',
	path: '/jira/filters',
};
